import { ProcessInstanceGeneral } from 'api/endpoints/processInstance';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync, isApiError } from 'container/models';
import { ApplicationError } from 'types/errorHandling';

import {
  IProcessInstanceRelatedDocumentRepo,
  ProcessInstanceRelatedDocumentWithHypermedia,
} from './IProcessInstanceRelatedDocumentRepo';

export class ProcessInstanceRelatedDocumentRepo
  extends BaseRepo
  implements IProcessInstanceRelatedDocumentRepo
{
  getRelatedDocuments = async (
    instance: ProcessInstanceGeneral
  ): ApiResponseAsync<Array<ProcessInstanceRelatedDocumentWithHypermedia>> => {
    const link = instance._links?.['getRelatedDocuments'];

    if (!link) {
      return buildBadRequestApiError(
        new Error('link "get related documents" is not available')
      );
    }

    const searchResult = await this.helpers.handleGet<
      ProcessInstanceRelatedDocumentWithHypermedia[]
    >(link.href);
    if (isApiError(searchResult)) {
      return searchResult;
    }
    return searchResult ?? [];
  };

  getRelatedDocumentFileLink = (
    document: ProcessInstanceRelatedDocumentWithHypermedia
  ): ApplicationError | Link => {
    const link = document._links?.['openFile'];

    if (!link) {
      return ApplicationError.FromError(
        new Error('link "open related documents file" is not available'),
        'link "open related documents file" is not available'
      );
    }

    return link;
  };
}
